import { getPublicEnv } from "@/config/get-public-env";

export const locales = getPublicEnv().NEXT_PUBLIC_LOCALES;
